export const TOP_BAR_HEIGHT = 52;
export const LEFT_BAR_WIDTH = 88;
export const FLYOUT_WIDTH = 250;